import store from "@/store";
import { KtznEventSubscriptionAction } from "@/framework/store/ktznEventSubscription/types";
import { AuthMutation } from "@/framework/store/auth/types";
import { ComponentMutation } from "@/framework/store/component/types";
import { ConversationMutation } from "@/framework/store/conversation/types";
import { LoginAccept } from "@/framework/repositories/authenticationRepository";
import { UserProfile } from "@/modules/auth/objects/userProfile";
import { SignInToken } from "@/modules/auth/objects/SignInToken";

export class CommonVuexStateRepository {
  setAuthStore() {
    store.commit(AuthMutation.SET_LAST_LOGIN_DATETIME, new Date().toString());
    store.commit(AuthMutation.SET_IS_USER_LOGGED_OUT, false);
  }

  setTokens(response: LoginAccept | SignInToken) {
    store.commit(AuthMutation.SET_ACCESS_TOKEN, response.access_token_v2);
    store.commit(AuthMutation.SET_REFRESH_TOKEN, response.refresh_token_v2);
    store.commit(AuthMutation.SET_SUBSCRIPTION_ENDPOINT, `wss://${response.subscription_endpoint}`);
    const res = response as LoginAccept;
    store.commit(AuthMutation.SET_ONE_TIME_TOKEN, res && res.onetime_token ? res.onetime_token : "");
  }

  clearAuthStore() {
    store.commit(AuthMutation.SET_ACCESS_TOKEN, "");
    store.commit(AuthMutation.SET_REFRESH_TOKEN, "");
    store.commit(AuthMutation.SET_IS_USER_LOGGED_OUT, true);
    store.commit(AuthMutation.SET_STAFF, {});
    store.commit(AuthMutation.LOGOUT);
    this.setQcUser({});
    this.setStaffMyself({});
    localStorage.clear();
  }

  async startWebSocket() {
    await store.dispatch(KtznEventSubscriptionAction.startWebsocketConnection, true);
    store.commit(ConversationMutation.SET_HAS_STARTED_APPSYNC_SUBSCRIPTION, true);
  }

  async stopWebSocket() {
    await store.dispatch(KtznEventSubscriptionAction.stopWebsocketConnection, true);
    store.commit(ConversationMutation.SET_HAS_STARTED_APPSYNC_SUBSCRIPTION, false);
  }

  async subscribeToUser(userId: string) {
    await store.dispatch(KtznEventSubscriptionAction.subscribeToUser, userId);
  }

  async subscribeToTenant(tenantId: number) {
    await store.dispatch(KtznEventSubscriptionAction.subscribeToTenant, tenantId);
  }

  async subscribeToConversation(conversationId: string) {
    await store.dispatch(KtznEventSubscriptionAction.subscribeToConversation, conversationId);
  }

  getOneTimeToken() {
    return store.getters.getOneTimeToken;
  }

  getSubscriptionEndpoint() {
    return store.getters.getSubscriptionEndpoint;
  }

  setQcUser(user: UserProfile | {}) {
    store.commit(AuthMutation.SET_USER, user);
  }

  setStaffMyself(staff: any) {
    store.commit(AuthMutation.SET_STAFF, staff);
  }

  setAppMode(appMode: string) {
    store.commit(ComponentMutation.SET_APP_MODE, appMode);
  }
}
